<template>
  <div class="cardAvatar">
    <div class="avatarOuterPnl">
      <div class="avatarInnerPnl">
        <div :class="avatarPnlClass">
          <v-avatar :class="[getAvatarColor(userId), 'mavAvatar']" size="130px">
            <img :src="img" v-if="renderImg" :alt="name" />
            <span class="mavAvatarText" v-else>{{formatInitials(fname, lname)}}</span>
          </v-avatar>
          <div class="mavAvatarAction" v-if="profile">
            <v-btn fab small dark @click="doUpload">
              <v-icon>mdi-camera</v-icon>
            </v-btn>
          </div>
        </div>
        <div class="mavNameDisplay">
          <span class="mavNameText">{{nameDisplay}}</span>
        </div>
        <div class="align-center mavNameDisplay" v-if="email">
          <v-icon class="email_icon">mdi-email</v-icon>
          <span class="mavEmailText">{{email}}</span>
        </div>
      </div>
    </div>
    <div class="cardAvatarAction">
      <slot name="action">

      </slot>
    </div>
  </div>
</template>

<script>
import { getAvatarColor } from '@/utils/global'
import { initials } from '@/utils/name'

export default {
  computed: {
    renderImg() {
      if (this.img) {
        return true
      } else {
        return false
      }
    },
    nameDisplay() {
      if (this.fname === '' && this.lname === '') {
        return ''
      } else {
        return this.lname + ', ' + this.fname
      }
    },
    avatarPnlClass() {
      if (this.profile) {
        return 'profile avatarPnl'
      } else {
        return 'avatarPnl'
      }
    }
  },
  methods: {
    doUpload() {
      this.$emit('upload')
    },
    getAvatarColor(userId) {
      return getAvatarColor(userId)
    },
    formatInitials(fname, lname) {
      return initials(fname, lname)
    }
  },
  props: {
    img: {
      type: String,
      default: undefined
    },
    fname: {
      type: String,
      default: ''
    },
    lname: {
      type: String,
      default: ''
    },
    profile: {
      // Add in this flag for profile page (hover action)
      type: Boolean,
      default: false
    },
    userId: {
      type: Number,
      default: 0
    },
    email: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss">
.cardAvatar {
  .avatarOuterPnl {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;

    .avatarInnerPnl {
      flex: 1;
      margin: -50px auto 0;
      text-align: center;
      .avatarPnl {
        position: relative;

        &.profile:hover {
          .mavAvatarAction {
            opacity: 1;
          }
          .mavAvatar {
            opacity: 0.5;
          }
        }
        .mavAvatarAction {
          transition: 0.5s ease;
          opacity: 0;
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
          -ms-transform: translate(-50%, -50%);
        }
        .mavAvatar {
          .mavAvatarText {
            font-size: 30px !important;
            font-weight: 400;
            line-height: 32px !important;
            letter-spacing: normal !important;
            color: #fff !important;
            text-transform: uppercase;
          }
        }
      }
      .mavNameDisplay {
        padding: 10px 0px;
        .mavNameText {
          min-height: 50px;
          max-width: 250px;
          text-overflow: ellipsis;
          overflow: hidden;
          font-size: 1.2em;
          text-transform: uppercase;
          color: #999;
        }
        .mavEmailText {
          text-overflow: ellipsis;
          overflow: hidden;
          font-size: 0.95em;
        }
      }
    }
  }
  .cardAvatarAction {
    position: absolute;
    right: 10px;
    top: 10px;
    display: inline-block;
    .btn {
      margin: 0;
    }
  }
  .email_icon {
    margin-right: 8px;
    color: #e5b228;
  }
}
</style>
